// src/api/config.js

// Единый базовый префикс для всех API-запросов на клиенте
// Приоритет переменных окружения:
// 1) VITE_API_BASE (Vite)
// 2) REACT_APP_API_BASE (CRA)
// 3) REACT_APP_BACKEND_URL (для обратной совместимости; трактуем как базовый путь, если это путь)
// 4) "/api" по умолчанию

function normalizeBase(input) {
  if (!input) return '';
  try {
    // Если это абсолютный URL (origin), оставляем как есть
    const u = new URL(input, window.location.origin);
    // Если пользователь передал только путь, URL сформируется на текущем origin
    // Нас интересует именно конечная строка, которую будет понимать axios как baseURL
    // Для относительного пути без origin нам нужно вернуть только pathname+search (обычно pathname)
    if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(input)) {
      // относительное значение, вернём только path (без origin)
      return u.pathname.replace(/\/$/, '');
    }
    return input.replace(/\/$/, '');
  } catch {
    // На всякий случай: если что-то не так — вернём как есть без завершающего слеша
    return String(input).replace(/\/$/, '');
  }
}

const viteBase = (typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_BASE : undefined);
const craBase  = (typeof process !== 'undefined' ? (process.env.REACT_APP_API_BASE || process.env.REACT_APP_BACKEND_URL) : undefined);

const resolved = normalizeBase(viteBase || craBase || '/api');

export const API_BASE = resolved;

console.log('API_BASE =', API_BASE);


export function joinApi(path) {
  const base = API_BASE || '';
  const suffix = String(path || '');
  if (!base) return suffix;
  if (!suffix) return base;
  return `${base.replace(/\/$/, '')}/${suffix.replace(/^\//, '')}`;
}

export default API_BASE;


